<div class="main-container main-container--report">
  <app-report-side-info (signature)="saveEmitter.emit($event)" />
  <div class="content-container">
    <app-report-one-pager />
  </div>
  @if (burgerOpen) {
    <div class="content-container" (click)="burgerOpen = false" [style.background-color]="'transparent'"></div>
  }
  <div class="action-container">
    <div class="left-container">
      <sag-ui-button color="secondary" (click)="goBack()">
        {{ "default.buttons.cancel" | translate }}
      </sag-ui-button>
    </div>
    <div class="right-container">
      @if (guard.isAdmin && !this.isReleased) {
        <input #fileUpload (change)="upload($event.target.files[0])" accept="application/pdf" class="file-input" style="display: none" type="file" />
        <sag-ui-button
          color="secondary"
          sag-ui-tooltip
          [tooltip]="'report.actions.uploadReportManually' | translate"
          icon="upload"
          [disabled]="disableButtons"
          [square]="true"
          (click)="fileUpload.value = ''; fileUpload.click()" />
      }
      <sag-ui-button color="primary" (click)="export()" [disabled]="disableButtons">
        {{ "default.buttons.print" | translate }}
      </sag-ui-button>
      @if (isEditableAsResponsible) {
        <sag-ui-button color="primary" [disabled]="disableButtons" (click)="saveEmitter.emit()">
          {{ "default.buttons.save" | translate }}
        </sag-ui-button>
      }
    </div>
  </div>
</div>
